import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// Services
import { ElasticService } from "./../../../services/elastic";
// External
import { AngularFireDatabase } from "angularfire2/database";
import { ApiService } from "./../../../services/api";

import { OAuthService } from "./../../../services/o-auth";
import { Club } from "./../../../models/club";
import { PostTypes } from "./../../../models/post-types";
import { FormsService } from "./../../../services/forms";
import { FormGroup, FormControl, Validators } from "@angular/forms";

import * as lodash from "lodash";
@Component({
  selector: "app-club-insights",
  templateUrl: "insight.component.html",
})
export class ClubInsightComponent implements OnInit {
  public club: any;
  public follow: any;
  public form: FormGroup;

  public notification: Array<{
    id: string;
    count: number;
    name: string;
    checkImage: string;
    unCheckImage: string;
    isActive: boolean;
  }>;
  public offerCount: number;
  public insightFollower: Array<any>;
  public notifyType = "";
  constructor(
    private apiService: ApiService,
    private route: Router,
    private elasticService: ElasticService,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    public formsService: FormsService
  ) {
    this.club = this.oAuthService.getClub();
    this.form = new FormGroup({
      title: new FormControl("", Validators.required),
      body: new FormControl("", Validators.required),
      author: new FormControl(this.club.cid),
    });
  }
  ngOnInit(): void {
    this.fireDatabase
      .object(`/user-followers/${this.club.cid}`)
      .subscribe((result) => {
        console.log(result);

        this.createNotification();

        this.getClubInsight();
        if (result && result.count > 0) {
          this.follow = [];
          this.follow = result;
          lodash.forEach(result.followers, (item, key) => {
            if (item) {
              //   console.log("item   " + item + "  key  " + key)
              const fireObject = this.fireDatabase
                .object(`/user-push-settings/${key}`)
                .subscribe((result) => {
                  //     console.log(result)
                  this.increaseNotification();
                  lodash.forEach(result, (item1, key1) => {
                    if (key1 == this.club.cid) {
                      //      console.log(item1)
                      if (item1) {
                        lodash.forEach(item1, (item2, key2) => {
                          for (var i = 0; i < this.notification.length; i++) {
                            if (key2 == this.notification[i].id && item2) {
                              this.notification[i].count--;
                            }
                          }
                        });
                      }
                    }
                  });
                });
            }
          });
        }
      });
    console.log(this.notification);
  }
  public followerClick(follow) {
    $("#myModal").modal("hide");
    this.route.navigate(["/home/components/followerDetail", follow.cid]);
  }
  private getClubInsight() {
    const fireObject = this.fireDatabase
      .object(`/users/${this.club.cid}/insights`)
      .subscribe((result) => {
        //  console.log(result)
        //     console.log(result)
        lodash.forEach(result, (item, key) => {
          for (var i = 0; i < this.notification.length; i++) {
            if (key == this.notification[i].id && item) {
              this.notification[i].isActive = false;
              //    console.log(key + "  " + this.notification[i].id + "  " + item)
              // console.log(this.notification)
            }
          }
        });
      });
  }

  public getFollower(id) {
    this.insightFollower = [];
    var followUid = [];
    lodash.forEach(this.follow.followers, (item, key) => {
      if (item) {
        followUid.push(key);
        const fireObject = this.fireDatabase
          .object(`/user-push-settings/${key}`)
          .subscribe((result) => {
            if (result) {
              lodash.forEach(result, (item1, key1) => {
                if (key1 == this.club.cid) {
                  if (item1) {
                    lodash.forEach(item1, (item2, key2) => {
                      if (id == key2 && item2) {
                        var i = followUid.indexOf(key);
                        if (i != -1) {
                          followUid.splice(i, 1);
                        }
                      } else {
                      }
                    });
                  }
                }
              });
            }
          });
      }
    });
    lodash.forEach(followUid, (item, key) => {
      this.fireDatabase.object(`/users/${item}`).subscribe((user: any) => {
        this.insightFollower.push(user);
      });
    });
    $("#myModal").modal("show");
  }
  public insightClick(not) {
    console.log(this.club.$key, not.id);
    if (not.isActive) {
      if (confirm("Are you sure, you want to disable the notification?")) {
        this.apiService
          .set(`/users/${this.club.cid}/insights/${not.id}`, true)
          .then(() => {
            // this.getClubInsight();
            this.ngOnInit();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    } else {
      if (confirm("Are you sure, you want to enable the notification?")) {
        this.apiService
          .set(`/users/${this.club.cid}/insights/${not.id}`, null)
          .then(() => {
            // this.getClubInsight();
            this.ngOnInit();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }
  createNotification() {
    this.notification = [];

    lodash.forEach(PostTypes, (item, key) => {
      this.notification.push({
        id: key,
        name: item[0],
        count: 0,
        checkImage: item[1],
        unCheckImage: item[2],
        isActive: true,
      });
    });
  }
  increaseNotification() {
    lodash.forEach(this.notification, (item, key) => {
      item.count++;
    });
    // console.log(this.notification)
  }
  openPopup(id) {
    $("#PostModal").modal("show");
    this.notifyType = id;
  }
  public submit() {
    var followUid = [];
    lodash.forEach(this.follow.followers, (item, key) => {
      if (item) {
        followUid.push(key);
        const fireObject = this.fireDatabase
          .object(`/user-push-settings/${key}`)
          .subscribe((result) => {
            if (result) {
              lodash.forEach(result, (item1, key1) => {
                if (key1 == this.club.cid) {
                  if (item1) {
                    lodash.forEach(item1, (item2, key2) => {
                      if (this.notifyType == key2 && item2) {
                        var i = followUid.indexOf(key);
                        if (i != -1) {
                          followUid.splice(i, 1);
                        }
                      }
                    });
                  }
                }
              });
            }
          });
      }
    });

    var form = this.form.value;
    form.type = this.notifyType;
    form.users = followUid;
    console.log(form);
    this.fireDatabase.database
      .ref(`/server-process/club-notification/${this.club.cid}`)
      .set(form)
      .then(() => {
        alert("Notification is Sent!");
        $("#PostModal").modal("hide");
      })
      .catch((error) => {
        console.error(error);
      });
  }
}
